import { render, staticRenderFns } from "./StudentSolvedQuizzesTable.vue?vue&type=template&id=361182f8&scoped=true&"
import script from "./StudentSolvedQuizzesTable.vue?vue&type=script&lang=ts&"
export * from "./StudentSolvedQuizzesTable.vue?vue&type=script&lang=ts&"
import style0 from "./StudentSolvedQuizzesTable.vue?vue&type=style&index=0&id=361182f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361182f8",
  null
  
)

export default component.exports